import { AuthService } from 'app/_services/auth.service';
import { ReportingStorageService } from 'app/_services/reportingStorageService';
import * as angular from 'angular';

class PagingSettingComponentCtrl implements ng.IController {
    uiLoadingSettings: boolean;

    pageOnly: boolean;
    amountSetting: AmountType;
    costSetting: CostType;
    pageSize: number;
    presetAmountSetting: boolean;
    presetCostSetting: boolean;
    presetPageSizeSetting: boolean;
    onInitializeFinished: () => void;
    onChange: () => void;

    constructor(
        private $timeout: ng.ITimeoutService,
        private appMemoryService,
        private authService: AuthService,
        private reportingStorageService: ReportingStorageService
    ) {}

    $onInit() {
        if (angular.isUndefined(this.pageOnly)) {
            this.pageOnly = false;
        }

        const sessionPagingSetting =
            this.reportingStorageService.fetchPagingSettingFromSession();

        this.presetAmountSetting = !!(
            this.amountSetting ||
            (sessionPagingSetting && sessionPagingSetting.amountSetting)
        );
        this.presetCostSetting = !!(
            this.costSetting ||
            (sessionPagingSetting && sessionPagingSetting.costSetting)
        );
        this.presetPageSizeSetting = !!(
            this.pageSize ||
            (sessionPagingSetting && sessionPagingSetting.pageSize)
        );

        this.amountSetting =
            this.amountSetting ||
            (sessionPagingSetting && sessionPagingSetting.amountSetting) ||
            'KILO';
        this.costSetting =
            this.costSetting ||
            (sessionPagingSetting && sessionPagingSetting.costSetting) ||
            'SUBUNIT';
        this.pageSize =
            this.pageSize ||
            (sessionPagingSetting && sessionPagingSetting.pageSize) ||
            10;

        this.uiLoadingSettings = false;
        this.authService.userLoginPromise.promise
            .then((loginResult: LoginResult) => {
                if (loginResult.tsoName) {
                    this.callOnInitialize();
                } else {
                    this.uiLoadingSettings = true;

                    this.appMemoryService
                        .platformSettings(
                            (res) => {
                                this.setAmountSettingsIfNotPreset(res.amount);
                                this.setCostSettingsIfNotPreset(res.cost);
                            },
                            () => {
                                // Just fall back to defaults.
                            }
                        )
                        .$promise.finally(() => {
                            this.uiLoadingSettings = false;
                            this.callOnInitialize();
                        });
                }
            })
            .catch(() => {
                this.callOnInitialize();
            });
    }

    setAmountSettingsIfNotPreset(value: AmountType) {
        if (!this.presetAmountSetting) {
            this.amountSetting = value;
        }
    }

    setCostSettingsIfNotPreset(value: CostType) {
        if (!this.presetCostSetting) {
            this.costSetting = value;
        }
    }

    callOnInitialize() {
        this.storeToSession();
        this.$timeout(() => {
            if (angular.isDefined(this.onInitializeFinished)) {
                this.onInitializeFinished();
            }
        });
    }

    changeSettings(setting: string, value) {
        this[setting] = value;
        this.storeToSession();
        this.$timeout(() => {
            if (angular.isDefined(this.onChange)) {
                this.onChange();
            }
        });
    }

    storeToSession() {
        const pagingSetting = {
            pageSize: this.pageSize,
            amountSetting: this.amountSetting || undefined,
            costSetting: this.costSetting || undefined
        };
        this.reportingStorageService.storePagingSettingToSession(pagingSetting);
    }
}

angular.module('app').component('pkpPagingSetting', {
    controller: PagingSettingComponentCtrl,
    template: require('app/_directives/paging-setting.component.html'),
    bindings: {
        onChange: '&?',
        onInitializeFinished: '&?',
        costSetting: '=?cost',
        amountSetting: '=?amount',
        pageSize: '=?',
        pageOnly: '<?'
    }
});
